/**
 * Single source of truth for the subscription gate on the web app.
 *
 * The status is cached in localStorage so route guards can decide
 * synchronously, before the `/auth/assinatura/status` request resolves.
 * Without the cache the guard would let a blocked page render for one frame
 * on a browser Back navigation.
 */

const STORAGE_KEY = "subscriptionStatus";

/** Statuses that must keep the user on the upgrade screen. */
const BLOCKED_STATUSES = ["expired", "blocked", "canceled", "cancelled"];

export const UPGRADE_ROUTE = "/assinatura/upgrade";

export function getSubscriptionStatus() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setSubscriptionStatus(status) {
  try {
    if (status) {
      localStorage.setItem(STORAGE_KEY, status);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // storage unavailable (private mode) - gate falls back to the API 402
  }
}

export function clearSubscriptionStatus() {
  setSubscriptionStatus(null);
}

export function isSubscriptionBlocked(status = getSubscriptionStatus()) {
  return BLOCKED_STATUSES.includes(status);
}
